import { render, staticRenderFns } from "./cargoposition.vue?vue&type=template&id=0940ae42&scoped=true&"
import script from "./cargoposition.vue?vue&type=script&lang=js&"
export * from "./cargoposition.vue?vue&type=script&lang=js&"
import style0 from "./cargoposition.vue?vue&type=style&index=0&id=0940ae42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0940ae42",
  null
  
)

export default component.exports